import { useTranslation } from 'react-i18next'

import { Alert, Switch } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ExtraCreditAccumulationToggle = ({ checked, onChange, label, disabled }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Switch checked={checked} onChange={onChange} label={label} disabled={disabled} />
      {checked && (
        <Alert type="warning">
          {t(
            'Activar esta opción puede ser peligroso. Clientes malintencionados podrían explotar el sistema para generar crédito extra ilimitado mediante ciclos repetidos de compra y devolución.'
          )}
        </Alert>
      )}
    </Styles.Container>
  )
}

export default ExtraCreditAccumulationToggle
